import { defineComponent, reactive, toRefs } from "vue";
import { useRouter } from "vue-router";
import { store } from "./store/PasswordChangeStore";
import { Log, Validator, presence, comparator, format, maxLength } from "~/extensions/utils";
import { Password } from "~/api/data";
import { useLoad } from "./composition/Load";
import { MsgBox } from "~/components/MsgBox";
import Loading from 'quasar/src/plugins/loading/Loading.js';
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import { commonStore } from "~/store/CommonStore";
import { PageID } from "~/extensions/utils/DefineTypes";
const log = Log.create("PasswordChangePage");
// エラーメッセージ
const requiredErrorMessage = "入力してください。";
const passwordPolicyErrorMessage = "新パスワードは大文字、小文字、数字のみで6文字以上20文字以内で入力してください。";
const equalityErrorMessage = "新パスワードと同じ値を入力してください。";
const comparatorErrorMessage = "現在のパスワードと違う値を入力してください。";
const constraints = {
    current: {
        presence: presence(false, requiredErrorMessage),
        length: maxLength(20)
    },
    new: {
        presence: presence(false, requiredErrorMessage),
        format: format({ pattern: new RegExp("^([a-zA-Z0-9]{6,20})$"), message: passwordPolicyErrorMessage }),
        comparator: comparator(comparatorErrorMessage)
    },
    confirm: {
        presence: presence(false, requiredErrorMessage),
        length: maxLength(20),
        comparator: comparator(equalityErrorMessage)
    }
};
export default defineComponent({
    name: "PasswordChangePage",
    components: {
        BreadcrumbList
    },
    async setup() {
        const data = reactive(new Password());
        const { loadChangeHtml, loading } = useLoad();
        const router = useRouter();
        // 画面名取得
        const pageName = commonStore.pageName(PageID.passwordChange);
        await loadChangeHtml();
        const valid = reactive(new Validator(data, constraints));
        const submit = async () => {
            valid.reset();
            if (valid.error || !data.current) {
                MsgBox.error("入力に不備があります。<br/>確認してください。");
                return;
            }
            try {
                Loading.show();
                await store.update(data);
                router.push({ name: "password-change-complete" });
            }
            catch (ex) {
                if (!valid.handle(ex)) {
                    log.error("PasswordChangePage", ex);
                    MsgBox.error(ex.data.errorMessage);
                    if (ex.data !== null && ex.data.code === "error.mail") {
                        router.push({ name: "password-change-complete" });
                    }
                }
            }
            finally {
                Loading.hide();
            }
        };
        return {
            ...toRefs(store),
            ...useLoad(),
            loading,
            loadChangeHtml,
            data,
            valid,
            submit,
            pageName,
            PageID
        };
    }
});
